import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { userSlice, refreshIdToken } from '../state/slices/user';
import { useAppDispatch, useAppSelector } from './../state/store';
import { useEffect } from 'react';
import ApiService from '../services/ApiService';

const apiService = ApiService.getInstance();

const ProtectedRoute = function({ children }) {
  const idToken = useAppSelector(userSlice.selectors.selectIdToken);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const authFailureHandler = useMemo((error) => {
    console.warn('Attempting to refresh token from ProtectedRoute', error);
    dispatch(refreshIdToken());
  }, [dispatch]);

  useEffect(() => {
    apiService.onFailure(authFailureHandler);
    return () => {
      apiService.removeFailureListener(authFailureHandler)
    }
  }, [authFailureHandler]);

  useEffect(() => {
    if (!idToken) {
      navigate('/login');
    }
  });
  return (
    <>
      {children}
    </>
  );
};


export default ProtectedRoute;